import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { CirclesWithBar } from "react-loader-spinner";

const Loading = () => {
  return (
    <div className="gradient-bg-services">
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Row>
          <Col>
            <div className="d-flex justify-content-center">
              <CirclesWithBar color="#00ffff" height={80} width={80} />
            </div>
            <h2 className="text-accent p-4">Portfolio App</h2>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Loading;
